<template>
  <div class="form-group row">
    <div class="col-sm-2 text-sm-right">
      <label>Matricula:</label>
    </div>
    <div class="col-sm-9 mb-3">
      <input type="text" class="form-control" id="inputMatricula" v-model="filtro.matricula" />
    </div>

    <div class="col-12 row btnAcoes">
      <div class="col-1"></div>
      <button class="btn btn-outline-success" @click.prevent="consultar()"> Pesquisar </button>
      <button class="btn btn-outline-danger" @click.prevent="limpar()"> Limpar </button>
    </div>
  </div>
</template>

<script>
import InteressadoService from '@/services/InteressadoService'
import eventBus from '@/uteis/eventBus'
import DataValues from '@/components/data-table-consulta/DataValues'

export default {
  props: {
    eventBusDataName: { required: true, type: String },
    eventBusPaginationName: { required: true, type: String }
  },

  data () {
    return {
      filtro: {
        tipoInteressado: 'SERVIDOR',
        matricula: '',
        range: 5
      },
      columns: [
        [
          { key: 'nome', title: 'Nome' },
          { key: 'tipoContatoExterno', title: 'Tipo', converter: 'tipoContatoExterno' }
        ], [
          { key: 'identificador', title: 'Identificador' }
        ]
      ]
    }
  },

  created () {
    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.consultar(numeroPagina)
    })

    this.service = new InteressadoService()
  },

  destroyed () {
    eventBus.$off(this.eventBusPaginationName)
  },

  methods: {
    consultar (page = 1) {
      const dadosSessao = this.$store.getters.getDadosSessao
      this.filtro = {
        ...this.filtro,
        offset: page,
        idDepartamento: dadosSessao.sessao.idDepartamento
      }

      this.service.buscarServidor(this.filtro).then(res => {
        const dataValues = new DataValues(res.data, 1, 10)
        eventBus.$emit(this.eventBusDataName, {
          ...dataValues,
          id: 'identificador',
          columns: this.columns
        })
      }).catch(err => {
        console.log(err)
      })
    },

    limpar () {
      this.filtro = {
        ...this.filtro,
        matricula: ''
      }
      this.consultar()
    }
  }
}
</script>
